import { MenuItemProps } from "@kaltura/ds-react-components";
import { ActionItemAutoProps } from "../../ActionItemAutoProps";
import { useState } from "react";
import { StyledListItemIcon, StyledMenuItem } from "../../StyledComponents";
import { Add24Icon } from "@kaltura/ds-react-icons";
import {
    CreateCategoryModal,
    CreateCategoryModalContentsProps,
} from "@kaltura/mediaspace-shared-create-category-modal";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export type AddSubGalleryActionProps = Omit<CreateCategoryModalContentsProps, "isChannel"> &
    MenuItemProps &
    ActionItemAutoProps & {
        /**
         * Menu item label
         */
        label: string;
    };

/**
 * "Add sub-gallery" menu action item for the gallery page
 */
export const AddSubGalleryAction = ({
    label,
    title,
    creationUrl,
    privacy,
    switches,
    onCloseMenu,
    ...menuItemProps
}: AddSubGalleryActionProps) => {
    const [openModal, setOpenModal] = useState(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const handleOpenModal = () => {
        setOpenModal(true);
        sendButtonAnalytics("Create sub gallery", ButtonClickAnalyticsType.CREATE);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        onCloseMenu?.();
    };

    return (
        <>
            <StyledMenuItem {...menuItemProps} onClick={handleOpenModal}>
                <StyledListItemIcon>
                    <Add24Icon />
                </StyledListItemIcon>
                {label}
            </StyledMenuItem>

            <CreateCategoryModal
                open={openModal}
                onCancel={handleCloseModal}
                isChannel={false}
                title={title}
                creationUrl={creationUrl}
                privacy={privacy}
                switches={switches}
                analyticsValue={"Create sub gallery"}
            />
        </>
    );
};
